export default [
  {
    name: "Disciplinary Cases",
    icon: "group",
    to: "/disciplinary/raised",
    enabled: true,
  },
  {
    name: "My Accused Disciplinary Cases",
    icon: "switch_account",
    to: "/disciplinary/accused",
    enabled: true,
  },
];
